import axios from 'axios';
import { message } from 'antd';
import localStorage from '../../../utils/localStorage';
import {
  API_AUTH,
  API_FRACAS,
  API_RUBUSMASTERS,
  //   API_DEVICEPARAMETER,
  //   API_DEVICETYPE,
  API_HIERARCHYMODULE,
  //   API_TRENDS,
  //   BOOKMARK,
  API_DEVICE
  //   API_ASSET
} from '../../../commons/api';
export async function getUserHeirarchyData() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deciceListApi = {
    method: 'GET',
    url: `${API_AUTH.ME}?SiteId=${siteId}&menuType=Web`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err && err.response && err.response.data && err.response.data.message);
      }
    });
}
export async function getHierarchyTreeData(value) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const getProcessArea = {
    method: 'GET',
    url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?HierarchyCode=${value}&SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(getProcessArea)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
}
export async function getDeviceList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'GET',
    url: `${API_DEVICE.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterGroup)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        (err && err.response && err.response.status && err.response.status === 500)
      ) {
        message.info(err.response.data.message);
        return [];
      }
    });
}
export async function submitReport(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS.ReportingCreate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function submitQuestions(data, api) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${api}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function updateQuestions(data, api) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${api}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function updateFailure(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${API_FRACAS.AnalysisUpdate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function updateReport(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${API_FRACAS.ReportingUpdate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function createAssign(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS.AssignCreate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function createFailure(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS.AnalysisCreate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function getDeviceTypeList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'GET',
    url: `${API_RUBUSMASTERS.DT_GET}?SiteId=${siteId}&ModuleCode=Metro_RS`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterGroup)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        (err && err.response && err.response.status && err.response.status === 500)
      ) {
        message.info(err.response.data.message);
        return [];
      }
    });
}
export async function createCorrectiveActions(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS.CorrectiveActionCreate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}
export async function onReportManagerAction(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'POST',
    url: `${API_FRACAS.UpdateReportStatus}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}

export async function DeleteAttachment(Id) {
  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');
  const header = {
    method: 'DELETE',
    url: `${API_FRACAS.DeleteAttachment}?SiteId=${siteId}&Id=${Id}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
}
export async function updateCorrectiveActions(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  const parameterGroup = {
    method: 'PATCH',
    url: `${API_FRACAS.CorrectiveActionUpdate}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data
  };

  return axios(parameterGroup)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (
        (err && err.response && err.response.status && err.response.status === 400) ||
        err.response.status === 500
      ) {
        message.info(err.response.data.message);
      }
    });
}